import { useContext } from 'react'
import { TenancyContext } from '../components/tenancy-provider'

export const useTenant = () => useContext(TenancyContext)
